import { Moon, Sun, Monitor } from "lucide-react";
import useTheme from "@/hooks/useTheme";

const META = {
  light:  { Icon: Sun,     label: "Light"  },
  dark:   { Icon: Moon,    label: "Dark"   },
  system: { Icon: Monitor, label: "System" },
};

/**
 * Pill-shaped Light/Dark/System tri-state toggle shown inline on the Home page.
 * Each tap cycles Light → Dark → System → Light. Reflects the current stored
 * preference (not the resolved theme), so "System" stays visible even when OS
 * is currently dark.
 */
export default function ThemeToggleButton({ className = "" }) {
  const { theme, cycle } = useTheme();
  const { Icon, label } = META[theme] || META.system;
  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Theme: ${label}. Click to cycle.`}
      data-testid="theme-toggle-button"
      data-theme={theme}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border bg-card hover:bg-accent transition-colors text-xs font-medium text-foreground ${className}`}
    >
      <Icon className="w-3.5 h-3.5" />
      {label}
    </button>
  );
}
